module.exports = __webpack_public_path__ + "static/media/noun_Camera_269752.daf3be59.svg";